<template>
	<modal-wrapper :modalId="modalId" :modalTitle="modalTitle" @close="close">
		<div class="modal-body">
			<div class="form-group row mb-3">
				<label class="col-md-4 col-form-label" for="eligibilityStatusId">
					Eligibility
				</label>
				<div class="col-md-7">
					<select name="eligibilityStatusId" class="form-select" v-model="eligibilityStatusId">
						<option value>Select...</option>
		              	<option v-for="status, id in eligibilityStatusOptions" :value="id">
		                 {{ status}}
		              </option>
		            </select>
				</div>
			</div>

			<div class="form-group row">
				<label class="col-md-4 col-form-label" for="enrollmentStatusId">
					Enrollment Status
				</label>
				<div class="col-md-7">
					<select name="enrollmentStatusId" class="form-select" v-model="enrollmentStatusId">
						<option value>Select...</option>
		              	<option v-for="status, id in enrollmentStatusOptions" :value="id">
		                 {{ status}}
		              </option>
		            </select>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<button class="btn btn-primary" @click="saveEditInfo">Save</button>
			<button type="button" class="btn btn-secondary" @click="close">Cancel</button>
		</div>
	</modal-wrapper>
</template>

<script>
import { mapState } from 'vuex'
import ModalWrapper from '../shared/ModalWrapper.vue'
export default {
	name: "SubstudyEditInfoForm",
	components: {
		ModalWrapper
	},
	props: {
		//
	},
	data() {
		return {
			modalId: 'edit-info-form-modal',
			modalTitle: 'Update information for selected participant(s)',
			eligibilityStatusId: null,
			enrollmentStatusId: null
		}
	},
	methods: {
		close() {
			this.$store.commit('substudies/setEditInfoFormOpen', false)
		},
		saveEditInfo() {
			this.$store.dispatch('substudies/updateSubstudyParticipant', {'eligibilityStatusId': this.eligibilityStatusId, 'enrollmentStatusId': this.enrollmentStatusId})
		}
	},
	computed: {
		...mapState({
			editInfoFormOpen: state => state.substudies.editInfoFormOpen,
			eligibilityStatusOptions: state => state.substudies.eligibilityStatusOptions,
			enrollmentStatusOptions: state => state.substudies.enrollmentStatusOptions,
        })
	},
	watch: {
        editInfoFormOpen (newVal, oldVal) {
            this.eligibilityStatusId = this.enrollmentStatusId = null
        }
    },
}
</script>